import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana74Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
      <rect width="1221" height="921" fill="url(#pattern0_1462_13739)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M331.986 308.59L340.357 326.527L297.308 345.66L280.566 312.107L312.853 301.415C326.007 299.024 329.546 305.89 331.986 308.59Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M248.459 321.482L280.19 312.176L296.113 343.267L253.064 362.4C249.396 354.826 245.238 341.832 242.303 336.092C240.727 333.009 240.6 329.904 241.136 327.442C241.862 324.102 245.18 322.444 248.459 321.482Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M355.904 360.007L340.359 326.524L297.31 345.657L315.247 380.336L355.904 360.007Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M372.643 394.689L355.902 360.011L315.244 380.34L329.594 413.822L372.643 394.689Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M286.549 430.562L328.403 410.234L312.857 376.751L271.004 397.08L286.549 430.562Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M271.003 397.079L312.856 376.75L296.115 343.268L253.065 362.401L271.003 397.079Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M388.189 429.364L372.643 394.686L330.79 413.819L346.336 448.497L388.189 429.364Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M303.29 465.239L286.549 430.56L328.402 410.231L343.948 444.91L303.29 465.239Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M404.929 462.849L363.075 484.373L346.334 448.499L388.187 429.366L404.929 462.849Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M420.476 497.528L404.93 462.85L363.077 483.178L378.623 516.661L420.476 497.528Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M318.829 499.917L359.486 479.589L343.941 444.91L303.283 465.239L318.829 499.917Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M335.574 534.597L318.833 499.919L360.686 479.59L376.232 513.073L335.574 534.597Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M436.022 529.814L420.476 497.527L378.623 516.66L394.169 550.143L436.022 529.814Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M450.811 562L436.021 529.814L392.972 550.143L408.34 582.989L450.811 562Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M352.314 569.273L335.572 534.595L376.23 513.07L392.971 548.945L352.314 569.273Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M378.002 631.139L367.861 606.345L409.715 586.017L425.327 618.793C417.642 622.908 400.087 632.127 391.35 636.078C382.613 640.029 379.62 634.432 378.002 631.139Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M367.862 606.345L409.715 586.016L391.778 550.142L352.316 569.275L367.862 606.345Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M460.52 601.507L425.329 618.792L408.34 582.988L450.812 561.999L464.16 589.161C466.102 596.075 462.542 600.273 460.52 601.507Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13739" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13739" transform="matrix(0.00164025 0 0 0.00217454 -3.01976 -1.46758)"/>
    </pattern>
    <image id="image0_1462_13739" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};